export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9339.ac2d5e42.jpg";